import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchFiltersModalV2.module.css';

const IconChip = props => {
  const { option, selected, iconSrc, onClick } = props;

  return (
    <button
      type="button"
      className={classNames(css.iconChip, {
        [css.iconChipSelected]: selected,
      })}
      onClick={onClick}
    >
      {iconSrc ? <img className={css.iconChipIcon} src={iconSrc} alt="" /> : null}
      <span className={css.iconChipLabel}>{option.label}</span>
    </button>
  );
};

IconChip.defaultProps = {
  selected: false,
  iconSrc: null,
};

IconChip.propTypes = {
  option: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  iconSrc: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default IconChip;
